var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 225,
    viewBox: "0 0 226 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.168,
    cy: 112.5,
    r: 112.5,
    fill: "url(#paint0_linear_5148_3363)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5148_3363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6203 151.968L53.4975 114.296C51.0581 111.886 51.0581 107.969 53.4975 105.558C55.9368 103.148 59.9008 103.148 62.3402 105.558L95.6781 138.502C96.1863 139.004 97.0072 139.004 97.5154 138.502L163.996 72.8079C166.435 70.3974 170.399 70.3974 172.838 72.8079C175.278 75.2184 175.278 79.1354 172.838 81.5459L101.581 151.968C98.8289 154.688 94.3724 154.688 91.6203 151.968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5148_3363",
    x1: 113.168,
    y1: 0,
    x2: 113.168,
    y2: 225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B884CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B76AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5148_3363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 83,
    fill: "white",
    transform: "translate(51.668 71)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/CheckedCircle.c05a83287e57196e986a4e1bf34b0ab7.svg";
export { ForwardRef as ReactComponent };